<template lang="pug">
  validation-observer(
    v-slot="{ invalid, validate }"
  )
    .d-flex.flex-column.gap-24
      template(v-if="readonly")
        div.ui-body-1(
          v-if="inputValue"
          v-html="inputValue"
        )
        dv-alert(
          v-else
        ) Нет ответа

      template(v-else)
        validation-provider(
          name="text"
          rules="required"
        )
          dv-textarea(
            v-model="inputValue"
            :counter="constants.INPUT_LENGTH.textArea"
            :rows="5"
            placeholder="Введите ваш ответ здесь..."
          )

      slot(
        :invalid="invalid"
        :validate="validate"
      )
</template>

<script>
import DvCard from '@/packages/ui/components/cards/DvCard.vue';
import DvAlert from '@/packages/ui/components/alerts/DvAlert.vue';
import DvTextarea from '@/packages/ui/components/inputs/DvTextarea.vue';
import { INPUT_LENGTH } from '@/constants/inputLength';

// Текстовый ответ с вариантами TYPE = 6
export default {
  name: 'QuestionTextVariants',
  components: {
    DvCard,
    DvAlert,
    DvTextarea,
  },
  props: {
    value: { type: Object, default: undefined },
    question: { type: Object, required: true },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      inputValue: undefined,
    };
  },
  computed: {
    constants() {
      return {
        INPUT_LENGTH,
      };
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val?.responseValue?.write_option) {
          this.inputValue = val.responseValue.write_option;
        }
      },
      immediate: true,
    },
    inputValue: {
      handler(val) {
        const { value } = this;

        this.$set(value, 'responseValue', {
          write_option: val,
        });
        this.$emit('input', value);
      },
      deep: true,
    },
  },
};
</script>
